import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CartActions } from '@spartacus/cart/base/core';
import type { Cart } from '@spartacus/cart/base/root';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { CustomPaymentTypeConnector } from '../../connectors/custom-payment-type.connector';
import { CustomCheckoutActions } from '../actions';

@Injectable()
export class CustomPaymentTypesEffects {
  protected logger = inject(LoggerService);
  getPaymentTypes$: Observable<CustomCheckoutActions.GetPaymentTypesSuccess | CustomCheckoutActions.GetPaymentTypesFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomCheckoutActions.LOAD_PAYMENT_TYPES),
      switchMap(() => {
        return this.paymentTypeConnector.getPaymentTypes().pipe(
          map((paymentTypes) => new CustomCheckoutActions.GetPaymentTypesSuccess(paymentTypes)),
          catchError((error) => of(new CustomCheckoutActions.GetPaymentTypesFail({ error: tryNormalizeHttpError(error, this.logger) })))
        );
      })
    )
  );

  setPaymentType$: Observable<CustomCheckoutActions.SetPaymentTypeSuccess | CustomCheckoutActions.SetPaymentTypeFail | CartActions.LoadCartSuccess> = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomCheckoutActions.SET_PAYMENT_TYPE),
      map((action: CustomCheckoutActions.SetPaymentType) => action.payload),
      switchMap((payload) => {
        return this.paymentTypeConnector.setPaymentType(payload.userId, payload.cartId, payload.typeCode, payload.poNumber).pipe(
          mergeMap((data) => {
            const cart = (data as Cart) ?? null;
            return [
              new CartActions.LoadCartSuccess({
                cart,
                userId: payload.userId,
                cartId: payload.cartId
              }),
              new CustomCheckoutActions.SetPaymentTypeSuccess(cart)
            ];
          }),
          catchError((error) => of(new CustomCheckoutActions.SetPaymentTypeFail(tryNormalizeHttpError(error, this.logger))))
        );
      })
    )
  );

  constructor(private actions$: Actions, private paymentTypeConnector: CustomPaymentTypeConnector) {}
}
